import {Col, Row, Container, CardBody, Card, CardFooter} from "reactstrap";
import { H3, H4, H6, P, Image } from 'AbstractElements';
import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PaginationComponent from 'Component/Common/PaginationComponent';
import { setFilters } from 'Services/Features/Order/orderSlice';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
import TableOrder from './TableOrder';
import InfoUserOrder from './InfoUserOrder';

const OrderContent = ({ setRefetch }) => {
    const orders = useSelector((state) => state.order.orders);
    const loading = useSelector((state) => state.order.loading);
    const pagination = useSelector((state) => state.order.pagination);
    const filters = useSelector(state => state.order.filters);
    const dispatch = useDispatch();
    
    return (
        <Fragment>
            <Container>
                <Row>
                    <Col sm="12">
                    { orders && orders.length > 0 ? (
                        orders.map((item, index) => (
                            <Card key={index}>
                                <CardBody>
                                    <div className="invoice">
                                        <InfoUserOrder item={item} setRefetch={setRefetch} />
                                        <TableOrder item={item} />
                                    </div>
                                </CardBody>
                                <CardFooter className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <span className="text-muted"><i><b>CATATAN : </b>{item.cs_notes || '-'}</i></span>
                                    </div>
                                </CardFooter>   
                            </Card>
                        ))
                    ) : (
                        <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                            <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                            <h5 style={{ fontSize: '24px' }}>Data tidak ditemukan</h5>
                        </div>
                    )}
                    </Col>
                    <div style={{ marginTop: '100px', display: 'flex', justifyContent: 'center' }}>
                        {loading === false && orders && orders.length > 0 && (
                            <PaginationComponent
                                pagination={pagination}
                                handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                                handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                                handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                            />
                        )}
                    </div>
                </Row>
            </Container>
        </Fragment>
    );
};

export default OrderContent;
